import * as bankAccountActions from "../../reduxV2/bankAccount/bankAccount.actions";
import * as bankAccountSelectors from "../../reduxV2/bankAccount/bankAccount.selectors";
export var isPerformingSubmitActionSelector = function () { return function (state) {
    return bankAccountSelectors.isCreatingContactBankAccount(state);
}; };
export var performingSubmitActionResultSelector = function (accountId, contactId) { return function (state) {
    var bankAccounts = bankAccountSelectors.getContactBankAccounts(state, {
        contactId: contactId,
        accountId: accountId,
    }) || [];
    if (bankAccounts.length === 0) {
        return false;
    }
    return bankAccounts[0].id;
}; };
export var performingSubmitActionResultSelectorIban = function (accountId, contactId) { return function (state) {
    var bankAccounts = bankAccountSelectors.getContactBankAccounts(state, {
        contactId: contactId,
        accountId: accountId,
    }) || [];
    if (bankAccounts.length === 0) {
        return false;
    }
    return bankAccounts[0];
}; };
export var performingSubmitActionErrorSelector = function () { return function (state) {
    return bankAccountSelectors.createContactBankAccountError(state);
}; };
export var submitActionCreator = function (accountId, contactId, onSuccess) {
    return function (formData) {
        return bankAccountActions.createContactBankAccountStart.getAction({
            accountId: accountId,
            contactId: contactId,
            data: formData,
            onSuccess: onSuccess,
        });
    };
};
